import {
  CommentModel,
  CommentResponse,
  DisplayEntitiesModel,
  DisplayEntitiesResponse,
  DisplayModel,
  DisplayResponse,
  TranslatableEntityModel,
  TranslatableEntityResponse,
} from 'types';

import { normalizeAttachment, normalizePreview } from './attachment';
import genericNormalizer from './generic';
import { normalizeMember } from './member';

export const normalizeComment = genericNormalizer<
  CommentResponse,
  CommentModel
>(({ from }) => ({
  text: from('text'),
}));

export const normalizeTranslatableEntity = genericNormalizer<
  TranslatableEntityResponse,
  TranslatableEntityModel
>(({ from, has }) => ({
  hideIfContext: has('hideIfContext', (hideIfContext) =>
    Boolean(hideIfContext),
  ),
  idContext: from('idContext'),
  translationKey: from('translationKey'),
  type: from('type'),
}));

export const normalizeDisplayEntities = genericNormalizer<
  DisplayEntitiesResponse,
  DisplayEntitiesModel
>(({ has }) => ({
  attachment: has('attachment', normalizeAttachment),
  attachmentPreview: has('attachmentPreview', normalizePreview),
  comment: has('comment', normalizeComment),
  contextOn: has('contextOn', normalizeTranslatableEntity),
  level: has('level', normalizeTranslatableEntity),
  memberCreator: has('memberCreator', normalizeMember),
  memberInviter: has('memberInviter', normalizeMember),
}));

export const normalizeDisplay = genericNormalizer<
  DisplayResponse,
  DisplayModel
>(({ has, from }) => ({
  entities: has('entities', normalizeDisplayEntities),
  translationKey: from('translationKey'),
}));



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/display.ts